import { url } from "@/lib/url"
import { PortfolioListQuery, ViewType } from "@/v2/graphql/public-generated-rq"

type Portfolio = PortfolioListQuery["portfolios"][number]

export function portfolioUrl(
  p: Portfolio,
  currentView: ViewType | undefined,
): string | undefined {
  // Decide which flavor (Investor vs Offtaker) to show for the Portfolio.
  //
  // If the backend says this person can see both flavors, the user is an
  // admin or investor. In that case we maintain their current view flavor.
  //
  // Otherwise we navigate to the flavor the backend directs. This is a Portfolio-level
  // decision because a Portfolio can override the Org's default receives-offers
  // vs self-financed setup.
  //
  const portfolioPid = p.pid
  if (p.views.includes(ViewType.Investor) && p.views.includes(ViewType.Offtaker)) {
    if (currentView === ViewType.Investor) {
      return url(["/s/portfolio/[portfolioPid]/properties", { portfolioPid }])
    } else if (currentView == ViewType.Offtaker) {
      return url(["/o/portfolio/[portfolioPid]", { portfolioPid }])
    }
  } else if (p.views.includes(ViewType.Investor)) {
    return url(["/s/portfolio/[portfolioPid]/properties", { portfolioPid }])
  } else if (p.views.includes(ViewType.Offtaker)) {
    return url(["/o/portfolio/[portfolioPid]", { portfolioPid }])
  }
  return undefined
}
